import { configureStore } from '@reduxjs/toolkit';
import adminReducer from '../reducers/adminSlice';
import sidebarReducer from '../reducers/sidebarSlice';
import csrfReducer from 'redux/csrfSlice';

export const store = configureStore({
  reducer: {
    admin: adminReducer,
    sidebar: sidebarReducer,
    csrf: csrfReducer,
  },
});
